<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3 flex mt-2">
          <li>
            <router-link to="/setup/leave-management" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>{{ $t("setup.label.ViewLeave") }}</h3>
          </li>
        </ul>
      </div>
      <div class="vx-col w-full">
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editData(id)"
                      size="small"
                      >{{ $t("setup.label.Edit") }}</vs-button
                    >
                    <!-- <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deleteUserDataPopup = true"
                      >{{ $t("setup.label.Delete") }}</vs-button
                    > -->
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="block overflow-x-auto">
            <table class="table w-full table-bordered table-striped">
              <tr>
                <td>
                  <b>{{ $t("setup.label.UserName") }}</b>
                </td>
                <td>{{ availableUserData.userName || availableUserData.userId }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.ConfigId") }}</b>
                </td>
                <td>{{ availableUserData.configId }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("customers.label.created_date") }}</b>
                </td>
                <td>{{ getDate(availableUserData.createdAt) }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("system.label.SessionDate") }}</b>
                </td>
                <td>{{ getDate(availableUserData.sessionDate) }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.SessionType") }}</b>
                </td>
                <td>{{ availableUserData.sessionType }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("setup.label.Status") }}</b>
                </td>
                <td>{{ availableUserData.status }}</td>
              </tr>
            </table>
          </div>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deleteUserDataPopup"
      :title="$t('setup.label.PriorityMapping')"
      @deletePressed="deleteUserData()"
      @cancelPressed="deleteUserDataPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      deleteUserDataPopup: false,
    };
  },

  computed: {
    ...mapState({
      availableUserData: (state) => state.teams.availableUserData,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    getTime(time) {
      return moment(time, "HH:mm:ss").format("HH:mm:ss");
    },
    async getUserAvailabilityDataById() {
      try {
        await this.$store.dispatch(
          "teams/getUserAvailabilityByIdAction",
          this.$route.params.id
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    editData() {
      this.$router.push(`/setup/leave-management/edit_leave/${this.$route.params.id}`);
    },
  },
  filters: {},
  created() {
    this.getUserAvailabilityDataById();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
